import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  token: null,
  error: null,
  setUser: (user) => set({ user, isAuthenticated: !!user, error: null }),
  setToken: (token) => set({ token }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  logout: () =>
    set({
      user: null,
      isAuthenticated: false,
      token: null,
      error: null,
      isLoading: true,
    }),
}));
